import { css } from "styled-components/macro";
import type { ElearningTheme } from "themes/elearning.theme";
import {
  Heading1Css,
  Heading2Css,
  Heading3Css,
  Heading4Css,
  Heading5Css,
  Heading6Css,
} from "./elements/Headings";
import { ParagraphCss } from "./elements/Texts";

interface Props {
  theme: ElearningTheme;
}
export const GlobalStylesCss = css`
  html {
    font-size: ${(props: Props) => props.theme.base};
  }
  *, ::after, ::before {
    box-sizing: border-box;
  }

  body {
    height: 100vh;
    background-color: ${(props: Props) => props.theme.palette.background};
    font-family: InterRegular, Helvetica, sans-serif;
    padding: 0;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: ${(props: Props) => props.theme.palette.neutral.black};
    text-align: left;
    position: relative;
    margin: 0 auto;
  }

  html, body, div, span, applet, object, iframe, h1, h2, h3, h4, h5, h6, p,
  blockquote, pre, a, abbr, acronym, address, big, cite, code, del, dfn, em,
  img, ins, kbd, q, s, samp, small, strike, strong, sub, sup, tt, var, b, u, i,
  center, dl, dt, dd, ol, ul, li, fieldset, form, label, legend, table, caption,
  tbody, tfoot, thead, tr, th, td, article, aside, canvas, details, embed, figure,
  figcaption, footer, header, hgroup, menu, nav, output, ruby, section, summary, time,
  mark, audio, video {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    vertical-align: baseline;
  }

  h1 {${Heading1Css}}
  h2 {${Heading2Css}}
  h3 {${Heading3Css}}
  h4 {${Heading4Css}}
  h5 {${Heading5Css}}
  h6 {${Heading6Css}}
  p {${ParagraphCss}}

  input {
    &:focus {
      outline: none !important;
    }
  }
`;
